/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Estimate plus additional details for detail screens.
 * @export
 * @interface EstimateDetailed
 */
export interface EstimateDetailed {
    /**
     * 
     * @type {number}
     * @memberof EstimateDetailed
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateDetailed
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateDetailed
     */
    documentId?: number | null;
    /**
     * Source system that generated the estimate
     * @type {string}
     * @memberof EstimateDetailed
     */
    sourceSystem: EstimateDetailedSourceSystemEnum;
    /**
     * Type of estimate
     * @type {string}
     * @memberof EstimateDetailed
     */
    kind: EstimateDetailedKindEnum;
    /**
     * Subtotal in cents
     * @type {number}
     * @memberof EstimateDetailed
     */
    subtotalCents: number;
    /**
     * Taxes in cents
     * @type {number}
     * @memberof EstimateDetailed
     */
    taxesCents: number;
    /**
     * Depreciation in cents
     * @type {number}
     * @memberof EstimateDetailed
     */
    depreciationCents: number;
    /**
     * Total value in cents
     * @type {number}
     * @memberof EstimateDetailed
     */
    totalCents: number;
    /**
     * 
     * @type {Date}
     * @memberof EstimateDetailed
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof EstimateDetailed
     */
    readonly documentFilename?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateDetailed
     */
    readonly roomCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateDetailed
     */
    readonly lineItemCount?: number | null;
}


/**
 * @export
 */
export const EstimateDetailedSourceSystemEnum = {
    Xactimate: 'xactimate',
    Symbility: 'symbility',
    Other: 'other'
} as const;
export type EstimateDetailedSourceSystemEnum = typeof EstimateDetailedSourceSystemEnum[keyof typeof EstimateDetailedSourceSystemEnum];

/**
 * @export
 */
export const EstimateDetailedKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type EstimateDetailedKindEnum = typeof EstimateDetailedKindEnum[keyof typeof EstimateDetailedKindEnum];


/**
 * Check if a given object implements the EstimateDetailed interface.
 */
export function instanceOfEstimateDetailed(value: object): value is EstimateDetailed {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('sourceSystem' in value) || value['sourceSystem'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('subtotalCents' in value) || value['subtotalCents'] === undefined) return false;
    if (!('taxesCents' in value) || value['taxesCents'] === undefined) return false;
    if (!('depreciationCents' in value) || value['depreciationCents'] === undefined) return false;
    if (!('totalCents' in value) || value['totalCents'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function EstimateDetailedFromJSON(json: any): EstimateDetailed {
    return EstimateDetailedFromJSONTyped(json, false);
}

export function EstimateDetailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateDetailed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'sourceSystem': json['sourceSystem'],
        'kind': json['kind'],
        'subtotalCents': json['subtotalCents'],
        'taxesCents': json['taxesCents'],
        'depreciationCents': json['depreciationCents'],
        'totalCents': json['totalCents'],
        'createdAt': (new Date(json['createdAt'])),
        'documentFilename': json['documentFilename'] == null ? undefined : json['documentFilename'],
        'roomCount': json['roomCount'] == null ? undefined : json['roomCount'],
        'lineItemCount': json['lineItemCount'] == null ? undefined : json['lineItemCount'],
    };
}

export function EstimateDetailedToJSON(json: any): EstimateDetailed {
    return EstimateDetailedToJSONTyped(json, false);
}

export function EstimateDetailedToJSONTyped(value?: Omit<EstimateDetailed, 'id'|'createdAt'|'documentFilename'|'roomCount'|'lineItemCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'documentId': value['documentId'],
        'sourceSystem': value['sourceSystem'],
        'kind': value['kind'],
        'subtotalCents': value['subtotalCents'],
        'taxesCents': value['taxesCents'],
        'depreciationCents': value['depreciationCents'],
        'totalCents': value['totalCents'],
    };
}

